<template>
    <div class="saas-page">
        <div class="saas-hero card-saas">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <router-link to="/blog">{{ trans('blog.blog') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('blog.edit_post') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ trans('blog.edit_post') }}</h1>
            </div>
        </div>
        <div class="card-saas mt-3">
            <div class="card-body">
                <blog-form :id="id"></blog-form>
            </div>
        </div>
    </div>
</template>
<script>
    import blogForm from './form'

    export default {
        components: { blogForm },
        data() {
            return {
                id: this.$route.params.id
            };
        }
    }
</script>
